import { render } from "./FooterView.vue?vue&type=template&id=39597dbe&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=39597dbe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2832102554/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39597dbe"]])

export default __exports__